// Total de horas em duas linhas (pedido do Lucas, 30/09/2026): em primeiro
// lugar com minutos ("37h30"), e embaixo, menor e cinza, o mesmo total em
// decimal ("37,5 h") — que era o único jeito mostrado antes.
//
// Sem antd de propósito: o atalho do cabeçalho é HTML puro e usa este mesmo
// componente, para as duas telas nunca mostrarem o total de jeitos diferentes.
//
// A segunda linha só aparece quando acrescenta algo (hora cheia não repete
// "8 h"). Numa fileira de colunas — total por dia — quem chama passa
// `reservar` quando ALGUMA coluna tem minuto quebrado: as demais guardam o
// espaço vazio e o que vem embaixo (folga, caixas) fica alinhado.
import type { CSSProperties } from 'react';
import { partesDoTotal } from './horasUtils';

export default function TotalHoras({ minutos, forte, reservar, vazio, alinhar = 'center', estilo, tamanhoDecimal = '0.8em' }: {
  minutos: number;
  /** Primeira linha em negrito (totais de coluna/rodapé). */
  forte?: boolean;
  /** Guarda o espaço da segunda linha mesmo sem decimal para mostrar. */
  reservar?: boolean;
  /** O que mostrar quando o total é zero (ex.: '—'). Sem ele, mostra "0 h". */
  vazio?: string;
  alinhar?: 'start' | 'center' | 'end';
  /** Estilo da primeira linha (tamanho, cor) — a segunda é sempre menor e cinza. */
  estilo?: CSSProperties;
  /** Tamanho da segunda linha; por padrão 80% da primeira (em números grandes, fixe em px). */
  tamanhoDecimal?: number | string;
}) {
  const zerado = !(minutos > 0);
  const { principal, decimal } = partesDoTotal(minutos);
  const mostrarDecimal = !zerado && !!decimal;
  return (
    <span style={{
      display: 'inline-flex', flexDirection: 'column', lineHeight: 1.25, whiteSpace: 'nowrap',
      alignItems: alinhar === 'center' ? 'center' : alinhar === 'end' ? 'flex-end' : 'flex-start',
    }}>
      <span style={{ fontWeight: forte && !zerado ? 600 : undefined, ...estilo }}>
        {zerado && vazio !== undefined ? vazio : principal}
      </span>
      {(mostrarDecimal || reservar) && (
        <span
          aria-hidden={!mostrarDecimal}
          title={mostrarDecimal ? 'O mesmo total em horas decimais' : undefined}
          style={{
            fontSize: tamanhoDecimal, fontWeight: 400, color: '#8c8c8c',
            visibility: mostrarDecimal ? 'visible' : 'hidden',
          }}>
          {mostrarDecimal ? decimal : '0 h'}
        </span>
      )}
    </span>
  );
}
